import React, { useEffect, useState } from "react";
import { CustomLabel, Modal, LinkOptionsContainer } from "../../../../styled/setting";

import { FaAngleDown, FaChevronDown, FaSortDown } from "react-icons/fa";
import { TfiSearch } from "react-icons/tfi";
import Search from "../../../common/search";
import Info from "../../../common/info";

const LinkOptions = ({ optionGroup, options, setOptions, changeSlide, prevActive }) => {
  const [data, setData] = useState([]);
  const [searched, setSearched] = useState("");
  const [openOptions, setOpenOptions] = useState([]);
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    setData([...optionGroup]);
    setChecked([...options].map((opt) => opt.id));
  }, [options]);

  // 옵션 그룹 열고 닫기
  const toggleOpen = (id) => {
    if (openOptions.includes(id)) {
      setOpenOptions((data) => [...data].filter((opt) => opt !== id));
    } else {
      setOpenOptions((data) => [...data, id]);
    }
  };

  // 옵션 체크/해제
  const toggleCheck = (id) => {
    if (checked.includes(id)) {
      setChecked((data) => [...data].filter((checked) => id !== checked));
    } else {
      setChecked((data) => [...data, id]);
    }
  };

  const onSubmit = () => {
    setOptions([...optionGroup].filter((opt) => checked.includes(opt.id)));
    changeSlide(prevActive);
  };

  // 옵션 이름으로 필터링
  const searchOption = (flag = false) => {
    setData(flag ? optionGroup : optionGroup.filter((ele) => ele.name.includes(searched)));
  };

  return (
    <LinkOptionsContainer>
      <Info
        message={`옵션 관리`}
        actions={[
          { label: "취소", func: () => changeSlide(prevActive), key: "cancel" },
          { label: "저장", func: () => onSubmit(), key: "add" },
        ]}
        setSearched={setSearched}
        searched={searched}
        searchEvent={searchOption}
        placeholder="옵션명을 입력해주세요"
      />
      <div className="contents">
        {data && data.length > 0 ? (
          <ul className="opt">
            {data.map((option) => (
              <li>
                <div className="info">
                  <p>
                    <CustomLabel>
                      <input
                        type="checkbox"
                        checked={checked.includes(option.id)}
                        onChange={(e) => toggleCheck(option.id)}
                      />
                      <div className="checkmark"></div>
                    </CustomLabel>
                    <span>{option.name}</span>
                  </p>
                  <button
                    onClick={() => toggleOpen(option.id)}
                    className={openOptions.includes(option.id) ? "active" : "inactive"}>
                    <FaChevronDown />
                  </button>
                </div>
                <ul className={openOptions.includes(option.id) ? "active" : "inactive"}>
                  {option.options.map((opt) => (
                    <li>
                      <span>{opt.value}</span>
                      <span>
                        +{opt?.addPrice ? formatNumber(toNumber(opt.addPrice) || 0) : 0}원
                      </span>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        ) : (
          <>옵션이 존재하지 않습니다.</>
        )}
      </div>
    </LinkOptionsContainer>
  );
};

export default LinkOptions;
